import React from "react";
import { NavLink } from "react-router-dom";
import { Icon } from "../util/Icon";

function SideBar(props) {
  return (
    <div
      className="d-flex flex-column flex-shrink-0 p-4 py-4 text-bg-dark"
      style={{ width: "280px" }}
    >
      <ul className="nav nav-pills flex-column mb-auto">
        {props.items.map((item, index) => (
          <li key={index}>
            <NavLink
              to={item.href}
              className={({ isActive }) =>
                isActive
                  ? "nav-link text-white sidebar-nav-active"
                  : "nav-link text-white sidebar-nav-link"
              }
              aria-current="page"
            >
              {item.iconName && (
                <Icon
                  className="bi pe-none me-2"
                  width="16"
                  height="16"
                  iconName={item.iconName}
                />
              )}

              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
      <hr />
    </div>
  );
}

export default SideBar;
